import type { AppDispatch, RootState } from '@/store/store'
import { getOrCreateFolderId } from '@/user_files/folders/utils/get-or-create-folder-id'
import { getOrFetchRootFolderId } from '@/user_files/folders/utils/get-or-fetch-root-folder-id'

type GetOrCreateUserFilesUploadFolderIdParams = {
  dispatch: AppDispatch
  folderName: string
  getState: () => RootState
  matterId: string
}

/**
 * Finds or creates the named Matter Files folder used by direct user-files uploads.
 * This runs on upload intent so normal page load does not prepare upload folders.
 */
export async function getOrCreateUserFilesUploadFolderId(params: GetOrCreateUserFilesUploadFolderIdParams): Promise<string> {
  const rootFolderId = await getOrFetchRootFolderId({ dispatch: params.dispatch, getState: params.getState, matterId: params.matterId })
  return getOrCreateFolderId({ dispatch: params.dispatch, getState: params.getState, parentId: rootFolderId, name: params.folderName })
}
